<template>
  <div>
    <el-card shadow="always">
      <EditForm
        ref="editForm"
        :disabled="disabled"
        :reviewEditDisabled="reviewEditDisabled"
        :pdProcessDictCode="pdProcessDictCode"
      />
      <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
        <el-button
          type="primary"
          size="small"
          @click="() => $refs.editForm.save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-card>
    <el-card shadow="always" class="mt-2" v-if="pdProcessDictCode">
      <FabricTable
        ref="fabricTable"
        :disabled="disabled"
        :pdProcessDictCode="pdProcessDictCode"
      />
    </el-card>
  </div>
</template>

<script>
import EditForm from '../components/edit-form'
import FabricTable from '../components/fabric-table'
export default {
  name: 'technology-processDictionary-detail',
  components: { EditForm, FabricTable },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    pdProcessDictCode() {
      return this.params.pdProcessDictCode
    },
    disabled() {
      return this.pageType === 'detail'
    },
    reviewEditDisabled() {
      return this.pageType === 'reviewEdit'
    },
  },
}
</script>
